export default __webpack_public_path__ + "static/media/G_D_btn__Archivio_Roll.529116d4.svg";